<template>
  <div class="items">
    <podcast
      v-for="(item, index) in list"
      :key="item.id"
      ref="players"
      v-bind:container-width="containerWidth"
      v-bind:display-player-inline="displayPlayerInline"
      v-bind:drop-to-live="dropToLive"
      v-bind:index="index"
      v-bind:podcast="item"
      v-bind:smc="smc"
      v-bind:use-m4a="useM4a"
      v-bind:api-prefix="apiPrefix"
      v-on:pauseothers="onPauseOthers(index)"
    ></podcast>
    <pagination
      v-bind:page-list="pageList"
      v-bind:category="category"
    ></pagination>
  </div>
</template>

<script>
import Pagination from './pagination';
import Podcast from './podcast';

export default {
  components: {
    Pagination,
    Podcast,
  },
  props: [
    'category',
    'containerWidth',
    'displayPlayerInline',
    'dropToLive',
    'list',
    'pageList',
    'smc',
    'useM4a',
    'apiPrefix',
  ],
  methods: {
    // Exclusivity fan-out: pause every OTHER item's media when one starts.
    // Vue3 populates `$refs.players` as an array for a `ref` on a v-for, but —
    // unlike the Vue1 `v-ref:players` array — its element ORDER is not
    // guaranteed to track the source list. So instead of the old positional
    // `pIndex !== index` compare, match on each child's own `index` prop
    // (behaviour-identical: pause all but the initiator, robust to ref order).
    onPauseOthers(index) {
      (this.$refs.players || []).forEach((player) => {
        if (player.index !== index) {
          player.pauseMedia();
        }
      });
    },

    switchCategory(category) {
      this.$parent.switchCategory(category);
    },

    switchPage(page, currentCategory) {
      this.$parent.switchPage(page, currentCategory);
    },

    // 🪤 BARE ON PURPOSE, both of them. The obvious tidy-up is a `typeof` guard here, and it
    // would be as vacuous as the one just removed from podcast.vue (review item S13): this
    // component is rendered from exactly one place, app.vue, which always defines both
    // hooks. The single mechanism that must hold is podcast.vue's try/catch, which wraps
    // this whole chain — app.vue's `informResize` and its `postMessage` included. Two
    // half-guards at two levels is how a codebase ends up believing it is protected twice
    // and finding out it was protected nowhere.
    imageLoaded() {
      this.$parent.imageLoaded();
    },

    // The layout-only half of the pair — a cover that FAILED still changed the box, but
    // nothing arrived to measure. See podcast.vue's imageFailed.
    imageFailed() {
      this.$parent.imageFailed();
    },
  },
};
</script>
